module.exports = __webpack_public_path__ + "static/img/phone.ae1ad01.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/phone.jpg
// module id = /jVV
// module chunks = 0